// extracted by mini-css-extract-plugin
export default {"layout":"MainGraph_layout__U5Les","graph":"MainGraph_graph__zy3Vv"};